import React, { useRef, memo } from 'react';
import { useField } from 'react-final-form';
import { useTranslation } from 'react-i18next';
import { FORM_VALUES } from '../../../../../utils/helpers/constants';
import { Input, InputTypeMap } from '../../../../ui/Input';
import { ValidationCounterText } from '../styled';
import { FormBlockWrapper } from '../FormBlockWrapper';
import {
  blockContentStyles,
  TextAreaWrapper,
  ValidationWrapper
} from './styled';

const DESCRIPTION_CHAR_LIMIT = 3000;

const DescriptionComponent = () => {
  const ref = useRef<HTMLInputElement | null>(null);
  const { t } = useTranslation();
  const { input: descriptionField } = useField(FORM_VALUES.description, {
    subscription: { value: true }
  });

  const description = descriptionField.value || '';
  const count = DESCRIPTION_CHAR_LIMIT - description.length;

  const inputPlaceholder = `${t('new_ad.describe_estate')} ${t(
    'new_ad.not_mention_phone'
  )}`;

  return (
    <FormBlockWrapper
      header={t('new_ad.description')}
      contentStyles={blockContentStyles}
    >
      <TextAreaWrapper>
        <Input
          refEl={ref}
          name={FORM_VALUES.description}
          type={InputTypeMap.description}
          maxLength={DESCRIPTION_CHAR_LIMIT.toString()}
          placeholder={inputPlaceholder}
        />
      </TextAreaWrapper>

      <ValidationWrapper>
        <ValidationCounterText
          data-cy="item-modal-validation-counter"
          $margin={15}
        >
          {t('new_ad.n_symbols', { count })}
        </ValidationCounterText>
      </ValidationWrapper>
    </FormBlockWrapper>
  );
};

export const Description = memo(DescriptionComponent);
